import styled from "styled-components"


export const ButtonBar = styled.div`
  display: flex;
  justify-content: ${props => (props.right ? "flex-end" : "space-evenly")};
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
  margin-top: 20px;
`
